import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { supplies } from '../../data/supplies';
import { SlideFrame } from '../deck/SlideFrame';
import { SlideHeader } from '../deck/SlideHeader';
import { highlightColors, type HighlightTone } from '../mockups/Highlight';
const legend: Array<{
  tone: HighlightTone;
  sample: string;
  meaning: string;
}> = [{
  tone: 'go',
  sample: 'Click',
  meaning: 'Green box = click here'
}, {
  tone: 'stop',
  sample: 'Not this',
  meaning: 'Red box = do not click'
}, {
  tone: 'info',
  sample: 'Link',
  meaning: 'Blue box = a helpful link'
}];
export function WhatYouNeedSlide() {
  const reduce = useReducedMotion();
  return <SlideFrame data-id="element-275" data-mp="2hwrh8a0fahgu">
      <SlideHeader eyebrow="Before you start" title="What you'll need" subtitle="About 20 minutes. Gather these first." data-id="element-276" data-mp="2mt883bz0b9xm" />
      <div className="mt-[2.2cqw] grid min-h-0 flex-1 grid-cols-12 gap-[3cqw]" data-id="element-277" data-mp="3t925q484vrfh">
        <ul className="col-span-7 flex flex-col justify-center" data-id="element-278" data-mp="21zbf3x01511">
          {supplies.map((supply, index) => {
          const Icon = supply.icon;
          return <motion.li key={supply.label} className="flex items-center gap-[1.4cqw] border-b border-mm-light-gray py-[0.9cqw] first:border-t" initial={reduce ? false : {
            opacity: 0,
            x: 12
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.35,
            delay: 0.08 + index * 0.06,
            ease: 'easeOut'
          }} data-id="element-279" data-mp="37lzbedtsqu9z" data-mpi={index}>
                <span className="flex h-[3cqw] w-[3cqw] shrink-0 items-center justify-center border-2 border-mm-charcoal bg-mm-white" data-id="element-280" data-mp="2nxzvypoaeyy8">
                  <Icon className="h-[1.6cqw] w-[1.6cqw] text-mm-charcoal" aria-hidden="true" data-id="element-281" data-mp="2jxg0rrn9y5eq" />
                </span>
                <span className="font-body text-[1.55cqw] leading-[1.25] text-mm-charcoal" data-id="element-282" data-mp="2evqns6ghrho0">
                  {supply.label}
                  {supply.detail ? <span className="block text-[1.2cqw] text-mm-mid-gray" data-id="element-283" data-mp="250oztdxycln0">{supply.detail}</span> : null}
                </span>
              </motion.li>;
        })}
        </ul>

        <div className="col-span-5 flex flex-col justify-center" data-id="element-284" data-mp="20bxmzv5wvx74">
          <div className="mm-cap border-2 border-mm-charcoal bg-mm-white p-[2cqw]" data-id="element-285" data-mp="1mbv9el4mzpxo">
            <p className="font-heading text-[1.7cqw] font-bold text-mm-black" data-id="element-286" data-mp="1qcymizvav7v7">
              How to read the pictures
            </p>
            <ul className="mt-[1.4cqw] flex flex-col gap-[1.3cqw]" data-id="element-287" data-mp="2e3kl80jezfsj">
              {legend.map(item => <li key={item.tone} className="flex items-center gap-[1.2cqw]" data-id="element-288" data-mp="2j0b1ooz4sdeh">
                  <span className="flex h-[2.6cqw] w-[8cqw] shrink-0 items-center justify-center border-[0.2cqw] font-heading text-[1.05cqw] font-bold" style={{
                borderColor: highlightColors[item.tone],
                color: highlightColors[item.tone]
              }} data-id="element-289" data-mp="25b0t7ixmo9go">
                    {item.sample}
                  </span>
                  <span className="font-body text-[1.45cqw] text-mm-charcoal" data-id="element-290" data-mp="31tyhy4cy22tg">{item.meaning}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </SlideFrame>;
}